import testTubeRight from "../assets/img/test-tube-right.gif";
import testTubeLeft from "../assets/img/test-tube-left.gif";
import matsRight from "../assets/img/mats-right.gif";
import matsLeft from '../assets/img/mats-left.gif';
import matsExternal from '../assets/img/mats-external.gif';
import matsBottom from "../assets/img/mats-bottom.gif";
import packagesGif from "../assets/img/packages.gif";

//Generic map
import matsGeneric from '../assets/img/mats-generic-map.gif';
import testTubeGeneric from '../assets/img/test-tubes-generic-map.gif';
import packagesGeneric from '../assets/img/packages-generic.gif';

export const MAP_ANIMATIONS = {
  NTO: {
    matsRight:{
      gifPath: matsRight,
      coords: [
        [1334, 2692],
        [1672, 2389],
      ]
    },
    matsLeft:{
      gifPath: matsLeft,
      coords: [
        [1468, 1258],
        [2020, 917],
      ]
    },
    matsExternal: {
      gifPath: matsExternal,
      coords: [
        [146, 3400],
        [914, 1681],
      ] 
    },
    matsBottom: {
      gifPath: matsBottom,
      coords: [
        [660, 2547],
        [1530, 1722],
      ]
    },
    testTubeRight: {
      gifPath: testTubeRight,
      coords: [
        [619, 3126],
        [2816, 1626],
      ]
    },
    testTubeLeft: {
      gifPath: testTubeLeft,
      coords: [
        [1183, 1910],
        [2714, 935],
      ]
    },
    packages: {
      gifPath: packagesGif,
      coords: [
        [505, 3010],
        [910, 1720],
      ]
    }
  },
  GENERIC: {
    mats:{
      gifPath: matsGeneric,
      coords: [
        [275, 3189],
        [1774, 1489],
      ]
    },
    testTubes:{
      gifPath: testTubeGeneric,
      coords: [
        [525, 914],
        [3524, 2613],
      ]
    },
    packages:{
      gifPath: packagesGeneric,
      coords: [
        [296, 3292],
        [796, 1492],
      ]
    },
  }
}